module.exports = __webpack_public_path__ + "img/user-friends-solid.f7258f77.svg";